import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import EnhancedTableToolbar from './EnhancedTableToolbar';
import EnhancedTableHead from './EnhancedTableHead';
import Icon from '@projeccions-pdc/react-icon';
import Button from '@material-ui/core/Button';
import zipcelx from 'zipcelx';

function defaultSorting(order, orderBy) {
    return order === 'desc'
        ? (a, b) => (b[orderBy] < a[orderBy] ? -1 : 1)
        : (a, b) => (a[orderBy] < b[orderBy] ? -1 : 1);
}

const styles = theme => ({
    root: {
        width: '100%',
        marginTop: theme.spacing(3),
    },
    table: {
        // minWidth: 1020,
    },
    tableWrapper: {
        overflowX: 'auto',
    },
    action: {
        display: 'inline-block',
        margin: '0px 5px',
    },
});

class EnhancedTable extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            order: 'asc',
            orderBy: props.columnData[0].id,
            selected: [],
            page: 0,
            rowsPerPage: 30,
            searchValue: '',
        };
    }

    static getDerivedStateFromProps(props, state) {
        let newSel = state.selected.map(a => a);
        for (let i = 0; i < state.selected.length; i++) {
            let currSel = state.selected[i];

            let found = props.data.filter((element) => {
                return element[props.rowId] === currSel;
            });
            if (!found || found.length === 0) {
                let index = newSel.indexOf(currSel);
                if (index > -1) {
                    newSel.splice(index, 1);
                }
            }
        }
        return {
            selected: newSel
        };
    }

    handleRequestSort = (event, property) => {
        const orderBy = property;
        let order = 'desc';

        if (this.state.orderBy === property && this.state.order === 'desc') {
            order = 'asc';
        }
        this.setState({ order, orderBy });
    };

    handleSelectAllClick = (event, checked) => {
        if (checked && this.props.multipleChoice !== false) {
            this.setState(state => ({ selected: this.props.data.map(n => n[this.props.rowId]) }));
            return;
        }
        this.setState({ selected: [] });
    };

    handleClick = (event, id) => {
        event.stopPropagation();
        const { selected } = this.state;
        const selectedIndex = selected.indexOf(id);
        let newSelected = [];

        if (this.props.multipleChoice !== false) {
            if (selectedIndex === -1) {
                newSelected = newSelected.concat(selected, id);
            } else if (selectedIndex === 0) {
                newSelected = newSelected.concat(selected.slice(1));
            } else if (selectedIndex === selected.length - 1) {
                newSelected = newSelected.concat(selected.slice(0, -1));
            } else if (selectedIndex > 0) {
                newSelected = newSelected.concat(
                    selected.slice(0, selectedIndex),
                    selected.slice(selectedIndex + 1),
                );
            }
        } else {
            if (selectedIndex !== -1) {
                newSelected = [];
            } else {
                newSelected = [id];
            }
        }
        this.setState({ selected: newSelected });
    };

    handleChangePage = (event, page) => {
        this.setState({ page });
    };

    handleChangeRowsPerPage = event => {
        this.setState({ rowsPerPage: event.target.value });
    };

    handleSearchValueChange = (evt) => {
        this.setState({ searchValue: evt.target.value });
    }

    isSelected = id => this.state.selected.indexOf(id) !== -1;

    filter = (current) => {

        let found = false;
        let result;
        for (let i = 0; i < this.props.columnData.length && !found; i++) {
            let column = this.props.columnData[i];
            if (column.isSortable === true) {
                let currValue = current[column.id];
                let searchValue = this.state.searchValue;
                if (currValue !== undefined && searchValue !== undefined) {
                    currValue = currValue.toLowerCase();
                    searchValue = searchValue.toLowerCase();
                    result = currValue.indexOf(searchValue) !== -1;
                    if (result === true) {
                        found = true;
                    }
                }
            }
        }
        return result;
    }

    handleItemClick = (event, n) => {
        if (this.props.onItemClick) {
            this.props.onItemClick(event, n[this.props.rowId]);
        }
    }

    handleAction = (onAction) => {
        if (onAction) {
            let selected = this.state.selected.map((elementId) => {
                return this.props.data.filter((element) => {
                    return element[this.props.rowId] === elementId;
                })[0];
            });
            onAction(selected);
        }
    };

    renderBoolean = (value) => {
        if (value === true) {
            return (
                < Icon primaryColor='#21ba45' name='fa-check' size='20px' />
            );
        }
        return (
            <Icon primaryColor='#db2828' name='fa-close' size='20px' />
        );
    }

    handleExportData = () => {
        let excelData = [];

        let headersRow = [];
        this.props.columnData.forEach((col) => {
            headersRow.push({
                value: col.name,
                type: 'string'
            });
        });
        excelData.push(headersRow);

        this.props.data.forEach((dataItem) => {
            let dataRow = [];
            this.props.columnData.forEach((col) => {
                let value;
                if (col.export) {
                    value = col.export(dataItem);
                } else {
                    if (col.isDate === true) {
                        value = new Date(dataItem[col.id]).toLocaleString();
                    } else {
                        value = dataItem[col.id];
                    }
                }

                dataRow.push({
                    value,
                    type: 'string'
                });
            });
            excelData.push(dataRow);
        });

        const config = {
            filename: this.props.tableTitle !== '' ? this.props.tableTitle : 'Export',
            sheet: { data: excelData }
        };
        // console.log(config);
        zipcelx(config);
    }

    getSorting = (order, orderBy) => {
        let column = this.props.columnData.find((col) => {
            return col.id === orderBy;
        });

        if (Array.isArray(column)) {
            column = column[0];
        }

        if (column && column.orderBy !== undefined) {
            let orderFunc = column.orderBy;
            if (order === 'desc') {
                return orderFunc;
            } else {
                return (a, b) => {
                    let result = orderFunc(a, b);
                    return result * -1;
                };
            }
        }
        return defaultSorting(order, orderBy);
    }

    render() {
        let { data } = this.props;
        const { classes } = this.props;
        const { order, orderBy, selected, rowsPerPage, page } = this.state;

        if (this.state.searchValue && this.state.searchValue !== '') {
            data = this.props.data.filter(this.filter);
        }

        const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);
        return (
            <Paper className={classes.root} data-id="data-table-container" elevation={2}>
                <EnhancedTableToolbar
                    numSelected={selected.length}
                    tableTitle={this.props.tableTitle}
                    searchValue={this.state.searchValue}
                    handleSearchValueChange={this.handleSearchValueChange}
                    actions={this.props.actions}
                    handleAction={this.handleAction}
                    handleExportData={this.handleExportData} />
                <div className={classes.tableWrapper}>
                    <Table className={classes.table} aria-labelledby="tableTitle" data-id="data-table">
                        <EnhancedTableHead
                            numSelected={selected.length}
                            order={order}
                            orderBy={orderBy}
                            onSelectAllClick={this.handleSelectAllClick}
                            onRequestSort={this.handleRequestSort}
                            rowCount={data.length}
                            columnData={this.props.columnData}
                            showSelectors={this.props.showSelectors}
                        />
                        <TableBody>
                            {/* {console.log(this.getSorting(order, orderBy))} */}
                            {data
                                .sort(this.getSorting('asc', this.props.rowId))
                                .sort(this.getSorting(order, orderBy))
                                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                .map(n => {
                                    const isSelected = this.isSelected(n[this.props.rowId]);
                                    return (
                                        <TableRow
                                            hover
                                            onClick={evt => this.handleItemClick(evt, n)}
                                            role="checkbox"
                                            aria-checked={isSelected}
                                            tabIndex={-1}
                                            key={n[this.props.rowId]}
                                            selected={isSelected}
                                            data-id={n[this.props.rowId]}
                                            data-type="data-table-row"
                                        >
                                            {this.props.showSelectors ?
                                                <TableCell padding="checkbox"> <Checkbox checked={isSelected} data-type="data-table-row-checkbox" onClick={event => this.handleClick(event, n[this.props.rowId])} /> </TableCell>
                                                : undefined}
                                            {this.props.columnData.map(column => {
                                                return (
                                                    <TableCell
                                                        key={n[this.props.rowId] + '-' + column.id}
                                                        data-id={column.id}
                                                        // numeric={column.numeric}
                                                        padding={this.props.showSelectors ? (column.disablePadding ? 'none' : 'default') : 'default'}
                                                    >
                                                        {column.render ?
                                                            (column.render(n))
                                                            :
                                                            (column.isDate === true ?
                                                                (n[column.id] !== null ?
                                                                    new Date(n[column.id]).toLocaleString()
                                                                    :
                                                                    '--'
                                                                )
                                                                :
                                                                column.isBoolean ?
                                                                    this.renderBoolean(n[column.id])
                                                                    :
                                                                    (n[column.id]))
                                                        }
                                                    </TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                })}
                            {this.props.fillEmptyRows === true ?
                                emptyRows > 0 && (
                                    <TableRow style={{ height: 49 * emptyRows }}>
                                        <TableCell colSpan={this.props.columnData.length} />
                                    </TableRow>
                                )
                                : undefined}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell colSpan={this.props.columnData.length} >
                                    {this.props.loadMore ?
                                        <Button variant="outlined" onClick={this.props.loadMore}>
                                            {'Load more'}
                                        </Button>
                                        : ''}
                                    {selected.length > 0 ?
                                        (
                                            this.props.actions.map((action) => {
                                                return (
                                                    <div key={action.action} className={this.props.classes.action}>
                                                        <Button variant="outlined" onClick={() => this.handleAction(action.onAction)}>
                                                            {action.icon ?
                                                                <Icon
                                                                    name={action.icon}
                                                                    size={'20px'}
                                                                />
                                                                : ''}
                                                            {` ${action.action}`}
                                                        </Button>
                                                    </div>
                                                );
                                            })
                                        )
                                        :
                                        ''
                                    }
                                </TableCell>
                            </TableRow>
                            <TableRow>
                                <TablePagination
                                    colSpan={this.props.columnData.length}
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    backIconButtonProps={{
                                        'aria-label': 'Previous Page',
                                    }}
                                    nextIconButtonProps={{
                                        'aria-label': 'Next Page',
                                    }}
                                    rowsPerPageOptions={[5, 10, 30, 50, 100, 200]}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </div>

            </Paper>
        );
    }
}

EnhancedTable.propTypes = {
    multipleChoice: PropTypes.bool,
    classes: PropTypes.object.isRequired,
    showSelectors: PropTypes.bool.isRequired,
    data: PropTypes.array.isRequired,
    columnData: PropTypes.array.isRequired,
    fillEmptyRows: PropTypes.bool,
    rowId: PropTypes.string.isRequired,
    tableTitle: PropTypes.string.isRequired,
    onItemClick: PropTypes.func,
    actions: PropTypes.oneOfType([
        PropTypes.array,
        PropTypes.object
    ]),
    loadMore: PropTypes.func,
};

export default withStyles(styles)(EnhancedTable);